








import Vue from 'vue'

import ActionButton from '@/components/btn-action.vue';

export default Vue.extend({
    components: {
        'action-button': ActionButton,
    },
    props: {
        buttons: Array,
        special: Boolean,
    }
})
